import React from 'react'
import {useHistory} from 'react-router-dom'

const DefaultMonthlyEventItem = ({ title, date, document, ...otherProps}) => {
	const history = useHistory();
	return (
		<li className="py-2" {...otherProps}>
      		<div className="flex text-sm flex-1 justify-between">

				<p className="appt" onClick={() => history.push(`/customerAppt/${document}`)}>{title}</p>
				{/* <p>{date}</p> */}
				{/* <p className="text-gray-500" >{document}</p> */}
      		</div>
    	</li>
	)
}

export default DefaultMonthlyEventItem 
